import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { me } from '../initial_state'
import PageTitle from '../features/ui/util/page_title'
import MarketplaceLayout from '../layouts/marketplace_layout'
import { openModal } from '../actions/modal'
import {
  MODAL_MARKETPLACE_LISTING_FILTER,
  BREAKPOINT_EXTRA_SMALL,
  MODAL_UNAUTHORIZED,
} from '../constants'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import MarketplaceListingFilterPanel from '../components/panel/marketplace_listing_filter_panel'
import MarketplaceListingCategoriesPanel from '../components/panel/marketplace_listing_categories_panel'
import TabBar from '../components/tab_bar'
import MarketplaceCategoriesScrollablePills from '../components/marketplace/marketplace_categories_scrollable_pills'
import Button from '../components/button'
import Text from '../components/text'
import List from '../components/list'

class MarketplaceListingsPage extends React.PureComponent {

  handleOnOpenFilterModal = () => {
    const { isXS } = this.props
    this.props.dispatch(openModal(MODAL_MARKETPLACE_LISTING_FILTER, { isXS }))
  }

  handleOnOpenModal = () => {
    this.props.dispatch(openModal(MODAL_UNAUTHORIZED)) 
  }

  render() {
    const { children, isXS, page } = this.props
    
    const isMainPage = page === 'marketplace'

    const xsTabs = !isXS ? undefined : [
      {
        title: 'Home',
        to: '/marketplace',
        active: isMainPage,
      },
      {
        title: 'Businesses',
        to: '/businesses',
      },
      // {
      //   title: 'Categories',
      //   to: '/marketplace/categories',
      // },
      !!me && {
        title: 'My Listings',
        to: '/marketplace/dashboard',
      },
    ].filter(Boolean)

    const actions = isXS ? [
      {
        attrTitle: 'Create new listing',
        icon: 'add',
        to: '/marketplace/create',
      },
      {
        attrTitle: 'Sort and Filter',
        icon: 'search',
        onClick: this.handleOnOpenFilterModal
      }
    ] : undefined

    const tabs = [
      {
        title: 'Home',
        to: '/marketplace',
        icon: 'shop',
        hideArrow: true,
        shouldHighlight: true,
        isActive: isMainPage && !!me,
      },
      {
        title: 'Businesses',
        to: '/businesses',
        icon: 'ul-list',
      },
      !me && {
        title: 'Categories',
        to: '/marketplace/categories',
        icon: 'ol-list',
      },
      !!me && {
        title: 'My Listings',
        to: '/marketplace/dashboard',
        icon: 'apps',
      },
      !!me && {
        title: 'Saved',
        to: '/marketplace/saved',
        icon: 'bookmark',
      },
    ].filter(Boolean)

    const sidebarLayout = [
      <div key='mlspcd-1' className={[_s.d, _s.w100PC, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
        <List items={tabs} size='large' padded />
      </div>,
      (<div key='mlspcd-2' className={[_s.d, _s.w100PC, _s.px5, _s.pt5].join(' ')}>
        <Button
          isBlock
          radiusSmall
          to={!!me ? '/marketplace/create' : undefined}
          onClick={!me ? this.handleOnOpenModal : undefined}
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>Create Listing →</Text>
        </Button>
      </div>),
      (<div key='mlspcd-3' className={[_s.d, _s.w100PC, _s.px5, _s.pt10].join(' ')}>
        <Button
          isBlock
          radiusSmall
          to='/marketplace/business/join'
          backgroundColor='brandLight'
          color='brand'
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>List your Business →</Text>
        </Button>
      </div>),
      <MarketplaceListingFilterPanel key='mlspcd-4' noPanel />,
      <MarketplaceListingCategoriesPanel key='mlspcd-5' noPanel />,
    ]

    return (
      <MarketplaceLayout
        page='marketplace'
        title='Marketplace'
        actions={actions}
        sidebarChildren={<SidebarPanelGroup layout={sidebarLayout} />}
        noRightSidebar
      >
        <PageTitle path='Marketplace' />

        {
          isXS &&
          <div className={[_s.d, _s.w100PC, _s.h40PX, _s.z6, _s.top0, _s.right0, _s.left0, _s.posSticky, _s.bgPrimary, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
            <TabBar tabs={xsTabs} shouldGrow />
          </div>
        }

        {
          isXS && isMainPage && 
          <div className={[_s.d, _s.w100PC, _s.flexWrap, _s.pt15, _s.pb5, _s.px5, _s.flexRow, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
            <Button
              isNarrow
              radiusSmall
              className={[_s.flexGrow1, _s.mb10, _s.mr5, _s.ml5].join(' ')}
              to='/marketplace/business/join'
            >
              <Text color='inherit' align='center' weight='medium'>List your Business →</Text>
            </Button>
            <Button
              isNarrow
              radiusSmall
              className={[_s.flexGrow1, _s.mb10, _s.mr5, _s.ml5].join(' ')}
              to='/marketplace/create'
            >
              <Text color='inherit' align='center' weight='medium'>Sell or List Item</Text>
            </Button>
          </div>
        }

        {
          isXS && isMainPage &&
          <div className={[_s.d, _s.mt15].join(' ')}>
            <MarketplaceCategoriesScrollablePills />
          </div>
        }
        
        {children}
      </MarketplaceLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

MarketplaceListingsPage.propTypes = {
  children: PropTypes.node.isRequired,
  isXS: PropTypes.bool.isRequired,
}

export default connect(mapStateToProps)(MarketplaceListingsPage)